export default __webpack_public_path__ + "static/media/close-drawer.ce53cb85.svg";